/**
 * @file
 * Patria mobile menu.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.mobile_menu = {
    attach: () => {

      const enMenu = "#block-mobile-navigation-en";
      const fiMenu = "#block-mobile-navigation-fi";
      const highlightLinks = ".mobile-navigation a.highlight";

      // Init menu.
      $(enMenu + ' > ul.menu,' + fiMenu + ' > ul.menu').slimmenu({
        resizeWidth: '1200',
        collapserTitle: '',
        animSpeed: 'medium',
        easingEffect: null,
        indentChildren: true,
      });

      // Add active class to toggle on click.
      $(enMenu + ' .collapse-button,' + fiMenu + ' .collapse-button').click(function () {
        $(this).toggleClass('active');
        $(this).closest('.region-navigation').toggleClass('menu-open');
      });

      // Modify menu on window resize.
      const width = $(window).width();
      $(window).on('resize', function () {
        if ($(window).width() <= 1200 && $(window).width() != width) {
          $(enMenu + ' .collapse-button,' + fiMenu + ' .collapse-button').removeClass('active');
        }
      });

      // Hide parent li element for a elements which have 'highlight' class
      $(highlightLinks).each(function () {
        $(this).parent().addClass("hidden");
      });

      // Language switcher
      const langSwitchToggle= $('.language-menu-toggle');
      const langMenu = $('.language-menu');

      langSwitchToggle.on('click', function () {
        $(this).toggleClass('active');
        langMenu.toggleClass('open');
      });
    }
  };

})(jQuery, Drupal);
